var _rect, _rect2, _rect3, _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _circle7, _path5, _circle8, _circle9, _circle10, _path6, _circle11, _path7, _circle12, _path8, _circle13, _path9, _circle14, _circle15, _path10, _circle16, _circle17, _path11, _circle18, _path12, _circle19, _path13, _circle20, _circle21, _path14, _circle22, _circle23, _path15, _circle24, _path16, _circle25, _path17, _circle26, _circle27, _path18, _circle28, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFourItemList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 176,
    viewBox: "0 0 21 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9996,
    y: 4.02295,
    width: 109.207,
    height: 2.00001,
    transform: "rotate(90 10.9996 4.02295)",
    fill: "#E8E8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9996,
    y: 4,
    width: 165,
    height: 2.00001,
    transform: "rotate(90 10.9996 4)",
    fill: "#E8E8E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9996,
    y: 4.11475,
    width: 164.885,
    height: 2,
    transform: "rotate(90 10.9996 4.11475)",
    fill: "#DBDBDB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83671,
    cy: 9.8367,
    r: 8.8367,
    transform: "rotate(90 9.83671 9.8367)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83671,
    cy: 9.8367,
    r: 6.8367,
    transform: "rotate(90 9.83671 9.8367)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02606 7.75098L8.25165 9.61035C7.77769 9.6696 7.41538 9.8291 7.16473 10.0889C6.91408 10.3486 6.78876 10.6631 6.78876 11.0322C6.78876 11.4287 6.93915 11.7614 7.23993 12.0303C7.54071 12.3037 7.94631 12.4404 8.45673 12.4404C8.9398 12.4404 9.32261 12.3105 9.60516 12.0508C9.88772 11.791 10.029 11.4743 10.029 11.1006C10.029 10.8545 9.98114 10.5605 9.88544 10.2187L11.4509 10.4307C11.4372 10.9502 11.5488 11.3467 11.7858 11.6201C12.0274 11.8936 12.3464 12.0303 12.7429 12.0303C13.0801 12.0303 13.349 11.93 13.5495 11.7295C13.75 11.529 13.8503 11.2624 13.8503 10.9297C13.8503 10.6016 13.7363 10.3213 13.5085 10.0889C13.2806 9.85645 12.9479 9.71517 12.5104 9.66504L12.8112 7.89453C13.4173 8.01758 13.9004 8.20215 14.2604 8.44824C14.625 8.69889 14.9099 9.04525 15.1149 9.4873C15.3246 9.93392 15.4294 10.4329 15.4294 10.9844C15.4294 11.9277 15.1286 12.6842 14.527 13.2539C14.0349 13.7233 13.4789 13.958 12.8591 13.958C11.9795 13.958 11.2777 13.4772 10.7536 12.5156C10.6306 13.0898 10.3548 13.5479 9.92645 13.8896C9.49807 14.236 8.98081 14.4092 8.37469 14.4092C7.49514 14.4092 6.74546 14.0879 6.12567 13.4453C5.50588 12.8027 5.19598 12.0029 5.19598 11.0459C5.19598 10.139 5.45575 9.38704 5.97528 8.79004C6.49937 8.19303 7.18296 7.84668 8.02606 7.75098Z",
    fill: "#DBDBDB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83866,
    cy: 9.86697,
    r: 8.8367,
    transform: "rotate(90 9.83866 9.86697)",
    fill: "white",
    stroke: "url(#paint0_linear_4722_64610)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15289 14.3364L5.36871 14.3364L5.36871 7.60303C6.04319 7.67594 6.68121 7.89469 7.28278 8.25928C7.8889 8.62386 8.69098 9.34391 9.68903 10.4194C10.4957 11.2853 11.0425 11.8162 11.3297 12.0122C11.7261 12.2765 12.1181 12.4087 12.5054 12.4087C12.9338 12.4087 13.2619 12.2925 13.4898 12.0601C13.7222 11.8322 13.8384 11.5155 13.8384 11.1099C13.8384 10.7088 13.7177 10.3898 13.4761 10.1528C13.2346 9.91585 12.8336 9.77913 12.273 9.74268L12.4644 7.82861C13.5217 7.94255 14.2805 8.30029 14.7408 8.90186C15.2011 9.50342 15.4312 10.2554 15.4312 11.1577C15.4312 12.1466 15.1646 12.9237 14.6314 13.4888C14.0982 14.0539 13.4351 14.3364 12.6422 14.3364C12.191 14.3364 11.7603 14.2544 11.3502 14.0903C10.9446 13.9308 10.5185 13.6756 10.0718 13.3247C9.77561 13.0923 9.34951 12.673 8.79352 12.0669C8.23753 11.4608 7.86839 11.0757 7.6861 10.9116C7.5038 10.7521 7.32607 10.6222 7.15289 10.522L7.15289 14.3364Z",
    fill: "url(#paint1_linear_4722_64610)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83866,
    cy: 9.86697,
    r: 8.8367,
    transform: "rotate(90 9.83866 9.86697)",
    fill: "white",
    stroke: "url(#paint2_linear_4722_64610)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15289 14.3364L5.36871 14.3364L5.36871 7.60303C6.04319 7.67594 6.68121 7.89469 7.28278 8.25928C7.8889 8.62386 8.69098 9.34391 9.68903 10.4194C10.4957 11.2853 11.0425 11.8162 11.3297 12.0122C11.7261 12.2765 12.1181 12.4087 12.5054 12.4087C12.9338 12.4087 13.2619 12.2925 13.4898 12.0601C13.7222 11.8322 13.8384 11.5155 13.8384 11.1099C13.8384 10.7088 13.7177 10.3898 13.4761 10.1528C13.2346 9.91585 12.8336 9.77913 12.273 9.74268L12.4644 7.82861C13.5217 7.94255 14.2805 8.30029 14.7408 8.90186C15.2011 9.50342 15.4312 10.2554 15.4312 11.1577C15.4312 12.1466 15.1646 12.9237 14.6314 13.4888C14.0982 14.0539 13.4351 14.3364 12.6422 14.3364C12.191 14.3364 11.7603 14.2544 11.3502 14.0903C10.9446 13.9308 10.5185 13.6756 10.0718 13.3247C9.77561 13.0923 9.34951 12.673 8.79352 12.0669C8.23753 11.4608 7.86839 11.0757 7.6861 10.9116C7.5038 10.7521 7.32607 10.6222 7.15289 10.522L7.15289 14.3364Z",
    fill: "url(#paint3_linear_4722_64610)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83866,
    cy: 9.86697,
    r: 8.8367,
    transform: "rotate(90 9.83866 9.86697)",
    fill: "white",
    stroke: "url(#paint4_linear_4722_64610)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15289 14.3364L5.36871 14.3364L5.36871 7.60303C6.04319 7.67594 6.68121 7.89469 7.28278 8.25928C7.8889 8.62386 8.69098 9.34391 9.68903 10.4194C10.4957 11.2853 11.0425 11.8162 11.3297 12.0122C11.7261 12.2765 12.1181 12.4087 12.5054 12.4087C12.9338 12.4087 13.2619 12.2925 13.4898 12.0601C13.7222 11.8322 13.8384 11.5155 13.8384 11.1099C13.8384 10.7088 13.7177 10.3898 13.4761 10.1528C13.2346 9.91585 12.8336 9.77913 12.273 9.74268L12.4644 7.82861C13.5217 7.94255 14.2805 8.30029 14.7408 8.90186C15.2011 9.50342 15.4312 10.2554 15.4312 11.1577C15.4312 12.1466 15.1646 12.9237 14.6314 13.4888C14.0982 14.0539 13.4351 14.3364 12.6422 14.3364C12.191 14.3364 11.7603 14.2544 11.3502 14.0903C10.9446 13.9308 10.5185 13.6756 10.0718 13.3247C9.77561 13.0923 9.34951 12.673 8.79352 12.0669C8.23753 11.4608 7.86839 11.0757 7.6861 10.9116C7.5038 10.7521 7.32607 10.6222 7.15289 10.522L7.15289 14.3364Z",
    fill: "url(#paint5_linear_4722_64610)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83671,
    cy: 10.1634,
    r: 8.8367,
    transform: "rotate(90 9.83671 10.1634)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83671,
    cy: 10.1634,
    r: 6.8367,
    transform: "rotate(90 9.83671 10.1634)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15094 14.6328L5.36676 14.6328L5.36676 7.89941C6.04124 7.97233 6.67926 8.19108 7.28082 8.55566C7.88694 8.92025 8.68903 9.6403 9.68707 10.7158C10.4937 11.5817 11.0406 12.1126 11.3277 12.3086C11.7242 12.5729 12.1161 12.7051 12.5035 12.7051C12.9319 12.7051 13.26 12.5889 13.4879 12.3564C13.7203 12.1286 13.8365 11.8118 13.8365 11.4062C13.8365 11.0052 13.7157 10.6862 13.4742 10.4492C13.2326 10.2122 12.8316 10.0755 12.2711 10.0391L12.4625 8.125C13.5198 8.23893 14.2785 8.59668 14.7388 9.19824C15.1991 9.7998 15.4293 10.5518 15.4293 11.4541C15.4293 12.443 15.1627 13.2201 14.6295 13.7852C14.0963 14.3503 13.4332 14.6328 12.6402 14.6328C12.189 14.6328 11.7584 14.5508 11.3482 14.3867C10.9426 14.2272 10.5165 13.972 10.0699 13.6211C9.77366 13.3887 9.34755 12.9694 8.79156 12.3633C8.23558 11.7572 7.86643 11.3721 7.68414 11.208C7.50185 11.0485 7.32412 10.9186 7.15094 10.8184L7.15094 14.6328Z",
    fill: "#DBDBDB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83866,
    cy: 9.86697,
    r: 8.8367,
    transform: "rotate(90 9.83866 9.86697)",
    fill: "white",
    stroke: "url(#paint6_linear_4722_64610)",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 61.8367,
    r: 8.8367,
    transform: "rotate(90 10.8367 61.8367)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 61.8367,
    r: 6.8367,
    transform: "rotate(90 10.8367 61.8367)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02606 59.751L9.25165 61.6104C8.77769 61.6696 8.41538 61.8291 8.16473 62.0889C7.91408 62.3486 7.78876 62.6631 7.78876 63.0322C7.78876 63.4287 7.93915 63.7614 8.23993 64.0303C8.54071 64.3037 8.94631 64.4404 9.45673 64.4404C9.9398 64.4404 10.3226 64.3105 10.6052 64.0508C10.8877 63.791 11.029 63.4743 11.029 63.1006C11.029 62.8545 10.9811 62.5605 10.8854 62.2187L12.4509 62.4307C12.4372 62.9502 12.5488 63.3467 12.7858 63.6201C13.0274 63.8936 13.3464 64.0303 13.7429 64.0303C14.0801 64.0303 14.349 63.93 14.5495 63.7295C14.75 63.529 14.8503 63.2624 14.8503 62.9297C14.8503 62.6016 14.7363 62.3213 14.5085 62.0889C14.2806 61.8564 13.9479 61.7152 13.5104 61.665L13.8112 59.8945C14.4173 60.0176 14.9004 60.2021 15.2604 60.4482C15.625 60.6989 15.9099 61.0452 16.1149 61.4873C16.3246 61.9339 16.4294 62.4329 16.4294 62.9844C16.4294 63.9277 16.1286 64.6842 15.527 65.2539C15.0349 65.7233 14.4789 65.958 13.8591 65.958C12.9795 65.958 12.2777 65.4772 11.7536 64.5156C11.6306 65.0898 11.3548 65.5479 10.9265 65.8896C10.4981 66.236 9.98081 66.4092 9.37469 66.4092C8.49514 66.4092 7.74546 66.0879 7.12567 65.4453C6.50588 64.8027 6.19598 64.0029 6.19598 63.0459C6.19598 62.139 6.45575 61.387 6.97528 60.79C7.49937 60.193 8.18296 59.8467 9.02606 59.751Z",
    fill: "#DBDBDB"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 61.867,
    r: 8.8367,
    transform: "rotate(90 10.8387 61.867)",
    fill: "white",
    stroke: "url(#paint7_linear_4722_64610)",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 66.3364L6.36871 66.3364L6.36871 59.603C7.04319 59.6759 7.68121 59.8947 8.28278 60.2593C8.8889 60.6239 9.69098 61.3439 10.689 62.4194C11.4957 63.2853 12.0425 63.8162 12.3297 64.0122C12.7261 64.2765 13.1181 64.4087 13.5054 64.4087C13.9338 64.4087 14.2619 64.2925 14.4898 64.0601C14.7222 63.8322 14.8384 63.5155 14.8384 63.1099C14.8384 62.7088 14.7177 62.3898 14.4761 62.1528C14.2346 61.9159 13.8336 61.7791 13.273 61.7427L13.4644 59.8286C14.5217 59.9425 15.2805 60.3003 15.7408 60.9019C16.2011 61.5034 16.4312 62.2554 16.4312 63.1577C16.4312 64.1466 16.1646 64.9237 15.6314 65.4888C15.0982 66.0539 14.4351 66.3364 13.6422 66.3364C13.191 66.3364 12.7603 66.2544 12.3502 66.0903C11.9446 65.9308 11.5185 65.6756 11.0718 65.3247C10.7756 65.0923 10.3495 64.673 9.79352 64.0669C9.23753 63.4608 8.86839 63.0757 8.6861 62.9116C8.5038 62.7521 8.32607 62.6222 8.15289 62.522L8.15289 66.3364Z",
    fill: "url(#paint8_linear_4722_64610)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 61.867,
    r: 8.8367,
    transform: "rotate(90 10.8387 61.867)",
    fill: "white",
    stroke: "url(#paint9_linear_4722_64610)",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 66.3364L6.36871 66.3364L6.36871 59.603C7.04319 59.6759 7.68121 59.8947 8.28278 60.2593C8.8889 60.6239 9.69098 61.3439 10.689 62.4194C11.4957 63.2853 12.0425 63.8162 12.3297 64.0122C12.7261 64.2765 13.1181 64.4087 13.5054 64.4087C13.9338 64.4087 14.2619 64.2925 14.4898 64.0601C14.7222 63.8322 14.8384 63.5155 14.8384 63.1099C14.8384 62.7088 14.7177 62.3898 14.4761 62.1528C14.2346 61.9159 13.8336 61.7791 13.273 61.7427L13.4644 59.8286C14.5217 59.9425 15.2805 60.3003 15.7408 60.9019C16.2011 61.5034 16.4312 62.2554 16.4312 63.1577C16.4312 64.1466 16.1646 64.9237 15.6314 65.4888C15.0982 66.0539 14.4351 66.3364 13.6422 66.3364C13.191 66.3364 12.7603 66.2544 12.3502 66.0903C11.9446 65.9308 11.5185 65.6756 11.0718 65.3247C10.7756 65.0923 10.3495 64.673 9.79352 64.0669C9.23753 63.4608 8.86839 63.0757 8.6861 62.9116C8.5038 62.7521 8.32607 62.6222 8.15289 62.522L8.15289 66.3364Z",
    fill: "url(#paint10_linear_4722_64610)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 61.867,
    r: 8.8367,
    transform: "rotate(90 10.8387 61.867)",
    fill: "white",
    stroke: "url(#paint11_linear_4722_64610)",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 66.3364L6.36871 66.3364L6.36871 59.603C7.04319 59.6759 7.68121 59.8947 8.28278 60.2593C8.8889 60.6239 9.69098 61.3439 10.689 62.4194C11.4957 63.2853 12.0425 63.8162 12.3297 64.0122C12.7261 64.2765 13.1181 64.4087 13.5054 64.4087C13.9338 64.4087 14.2619 64.2925 14.4898 64.0601C14.7222 63.8322 14.8384 63.5155 14.8384 63.1099C14.8384 62.7088 14.7177 62.3898 14.4761 62.1528C14.2346 61.9159 13.8336 61.7791 13.273 61.7427L13.4644 59.8286C14.5217 59.9425 15.2805 60.3003 15.7408 60.9019C16.2011 61.5034 16.4312 62.2554 16.4312 63.1577C16.4312 64.1466 16.1646 64.9237 15.6314 65.4888C15.0982 66.0539 14.4351 66.3364 13.6422 66.3364C13.191 66.3364 12.7603 66.2544 12.3502 66.0903C11.9446 65.9308 11.5185 65.6756 11.0718 65.3247C10.7756 65.0923 10.3495 64.673 9.79352 64.0669C9.23753 63.4608 8.86839 63.0757 8.6861 62.9116C8.5038 62.7521 8.32607 62.6222 8.15289 62.522L8.15289 66.3364Z",
    fill: "url(#paint12_linear_4722_64610)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 62.1634,
    r: 8.8367,
    transform: "rotate(90 10.8367 62.1634)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 62.1634,
    r: 6.8367,
    transform: "rotate(90 10.8367 62.1634)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15094 66.6328L6.36676 66.6328L6.36676 59.8994C7.04124 59.9723 7.67926 60.1911 8.28082 60.5557C8.88694 60.9202 9.68903 61.6403 10.6871 62.7158C11.4937 63.5817 12.0406 64.1126 12.3277 64.3086C12.7242 64.5729 13.1161 64.7051 13.5035 64.7051C13.9319 64.7051 14.26 64.5889 14.4879 64.3564C14.7203 64.1286 14.8365 63.8118 14.8365 63.4062C14.8365 63.0052 14.7157 62.6862 14.4742 62.4492C14.2326 62.2122 13.8316 62.0755 13.2711 62.0391L13.4625 60.125C14.5198 60.2389 15.2785 60.5967 15.7388 61.1982C16.1991 61.7998 16.4293 62.5518 16.4293 63.4541C16.4293 64.443 16.1627 65.2201 15.6295 65.7852C15.0963 66.3503 14.4332 66.6328 13.6402 66.6328C13.189 66.6328 12.7584 66.5508 12.3482 66.3867C11.9426 66.2272 11.5165 65.972 11.0699 65.6211C10.7737 65.3887 10.3476 64.9694 9.79156 64.3633C9.23558 63.7572 8.86643 63.3721 8.68414 63.208C8.50185 63.0485 8.32412 62.9186 8.15094 62.8184L8.15094 66.6328Z",
    fill: "#DBDBDB"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 61.867,
    r: 8.8367,
    transform: "rotate(90 10.8387 61.867)",
    fill: "white",
    stroke: "url(#paint13_linear_4722_64610)",
    strokeWidth: 2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 111.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 111.837)",
    fill: "white",
    stroke: "url(#paint14_linear_4722_64610)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 116.306L6.36871 116.306L6.36871 109.573C7.04319 109.646 7.68121 109.864 8.28278 110.229C8.8889 110.594 9.69098 111.314 10.689 112.389C11.4957 113.255 12.0425 113.786 12.3297 113.982C12.7261 114.246 13.1181 114.378 13.5054 114.378C13.9338 114.378 14.2619 114.262 14.4898 114.03C14.7222 113.802 14.8384 113.485 14.8384 113.08C14.8384 112.679 14.7177 112.36 14.4761 112.123C14.2346 111.886 13.8336 111.749 13.273 111.712L13.4644 109.798C14.5217 109.912 15.2805 110.27 15.7408 110.872C16.2011 111.473 16.4312 112.225 16.4312 113.127C16.4312 114.116 16.1646 114.893 15.6314 115.458C15.0982 116.024 14.4351 116.306 13.6422 116.306C13.191 116.306 12.7603 116.224 12.3502 116.06C11.9446 115.901 11.5185 115.645 11.0718 115.294C10.7756 115.062 10.3495 114.643 9.79352 114.037C9.23753 113.431 8.86839 113.045 8.6861 112.881C8.5038 112.722 8.32607 112.592 8.15289 112.492L8.15289 116.306Z",
    fill: "url(#paint15_linear_4722_64610)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 111.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 111.837)",
    fill: "white",
    stroke: "url(#paint16_linear_4722_64610)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 116.306L6.36871 116.306L6.36871 109.573C7.04319 109.646 7.68121 109.864 8.28278 110.229C8.8889 110.594 9.69098 111.314 10.689 112.389C11.4957 113.255 12.0425 113.786 12.3297 113.982C12.7261 114.246 13.1181 114.378 13.5054 114.378C13.9338 114.378 14.2619 114.262 14.4898 114.03C14.7222 113.802 14.8384 113.485 14.8384 113.08C14.8384 112.679 14.7177 112.36 14.4761 112.123C14.2346 111.886 13.8336 111.749 13.273 111.712L13.4644 109.798C14.5217 109.912 15.2805 110.27 15.7408 110.872C16.2011 111.473 16.4312 112.225 16.4312 113.127C16.4312 114.116 16.1646 114.893 15.6314 115.458C15.0982 116.024 14.4351 116.306 13.6422 116.306C13.191 116.306 12.7603 116.224 12.3502 116.06C11.9446 115.901 11.5185 115.645 11.0718 115.294C10.7756 115.062 10.3495 114.643 9.79352 114.037C9.23753 113.431 8.86839 113.045 8.6861 112.881C8.5038 112.722 8.32607 112.592 8.15289 112.492L8.15289 116.306Z",
    fill: "url(#paint17_linear_4722_64610)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 111.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 111.837)",
    fill: "white",
    stroke: "url(#paint18_linear_4722_64610)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 116.306L6.36871 116.306L6.36871 109.573C7.04319 109.646 7.68121 109.864 8.28278 110.229C8.8889 110.594 9.69098 111.314 10.689 112.389C11.4957 113.255 12.0425 113.786 12.3297 113.982C12.7261 114.246 13.1181 114.378 13.5054 114.378C13.9338 114.378 14.2619 114.262 14.4898 114.03C14.7222 113.802 14.8384 113.485 14.8384 113.08C14.8384 112.679 14.7177 112.36 14.4761 112.123C14.2346 111.886 13.8336 111.749 13.273 111.712L13.4644 109.798C14.5217 109.912 15.2805 110.27 15.7408 110.872C16.2011 111.473 16.4312 112.225 16.4312 113.127C16.4312 114.116 16.1646 114.893 15.6314 115.458C15.0982 116.024 14.4351 116.306 13.6422 116.306C13.191 116.306 12.7603 116.224 12.3502 116.06C11.9446 115.901 11.5185 115.645 11.0718 115.294C10.7756 115.062 10.3495 114.643 9.79352 114.037C9.23753 113.431 8.86839 113.045 8.6861 112.881C8.5038 112.722 8.32607 112.592 8.15289 112.492L8.15289 116.306Z",
    fill: "url(#paint19_linear_4722_64610)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 112.133,
    r: 8.8367,
    transform: "rotate(90 10.8367 112.133)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 112.133,
    r: 6.8367,
    transform: "rotate(90 10.8367 112.133)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15094 116.603L6.36676 116.603L6.36676 109.869C7.04124 109.942 7.67926 110.161 8.28082 110.525C8.88694 110.89 9.68903 111.61 10.6871 112.686C11.4937 113.551 12.0406 114.082 12.3277 114.278C12.7242 114.543 13.1161 114.675 13.5035 114.675C13.9319 114.675 14.26 114.559 14.4879 114.326C14.7203 114.098 14.8365 113.782 14.8365 113.376C14.8365 112.975 14.7157 112.656 14.4742 112.419C14.2326 112.182 13.8316 112.045 13.2711 112.009L13.4625 110.095C14.5198 110.209 15.2785 110.566 15.7388 111.168C16.1991 111.77 16.4293 112.521 16.4293 113.424C16.4293 114.413 16.1627 115.19 15.6295 115.755C15.0963 116.32 14.4332 116.603 13.6402 116.603C13.189 116.603 12.7584 116.521 12.3482 116.356C11.9426 116.197 11.5165 115.942 11.0699 115.591C10.7737 115.358 10.3476 114.939 9.79156 114.333C9.23558 113.727 8.86643 113.342 8.68414 113.178C8.50185 113.018 8.32412 112.888 8.15094 112.788L8.15094 116.603Z",
    fill: "#DBDBDB"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 111.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 111.837)",
    fill: "white",
    stroke: "url(#paint20_linear_4722_64610)",
    strokeWidth: 2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 165.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 165.837)",
    fill: "white",
    stroke: "url(#paint21_linear_4722_64610)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 170.306L6.36871 170.306L6.36871 163.573C7.04319 163.646 7.68121 163.864 8.28278 164.229C8.8889 164.594 9.69098 165.314 10.689 166.389C11.4957 167.255 12.0425 167.786 12.3297 167.982C12.7261 168.246 13.1181 168.378 13.5054 168.378C13.9338 168.378 14.2619 168.262 14.4898 168.03C14.7222 167.802 14.8384 167.485 14.8384 167.08C14.8384 166.679 14.7177 166.36 14.4761 166.123C14.2346 165.886 13.8336 165.749 13.273 165.712L13.4644 163.798C14.5217 163.912 15.2805 164.27 15.7408 164.872C16.2011 165.473 16.4312 166.225 16.4312 167.127C16.4312 168.116 16.1646 168.893 15.6314 169.458C15.0982 170.024 14.4351 170.306 13.6422 170.306C13.191 170.306 12.7603 170.224 12.3502 170.06C11.9446 169.901 11.5185 169.645 11.0718 169.294C10.7756 169.062 10.3495 168.643 9.79352 168.037C9.23753 167.431 8.86839 167.045 8.6861 166.881C8.5038 166.722 8.32607 166.592 8.15289 166.492L8.15289 170.306Z",
    fill: "url(#paint22_linear_4722_64610)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 165.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 165.837)",
    fill: "white",
    stroke: "url(#paint23_linear_4722_64610)",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 170.306L6.36871 170.306L6.36871 163.573C7.04319 163.646 7.68121 163.864 8.28278 164.229C8.8889 164.594 9.69098 165.314 10.689 166.389C11.4957 167.255 12.0425 167.786 12.3297 167.982C12.7261 168.246 13.1181 168.378 13.5054 168.378C13.9338 168.378 14.2619 168.262 14.4898 168.03C14.7222 167.802 14.8384 167.485 14.8384 167.08C14.8384 166.679 14.7177 166.36 14.4761 166.123C14.2346 165.886 13.8336 165.749 13.273 165.712L13.4644 163.798C14.5217 163.912 15.2805 164.27 15.7408 164.872C16.2011 165.473 16.4312 166.225 16.4312 167.127C16.4312 168.116 16.1646 168.893 15.6314 169.458C15.0982 170.024 14.4351 170.306 13.6422 170.306C13.191 170.306 12.7603 170.224 12.3502 170.06C11.9446 169.901 11.5185 169.645 11.0718 169.294C10.7756 169.062 10.3495 168.643 9.79352 168.037C9.23753 167.431 8.86839 167.045 8.6861 166.881C8.5038 166.722 8.32607 166.592 8.15289 166.492L8.15289 170.306Z",
    fill: "url(#paint24_linear_4722_64610)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 165.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 165.837)",
    fill: "white",
    stroke: "url(#paint25_linear_4722_64610)",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15289 170.306L6.36871 170.306L6.36871 163.573C7.04319 163.646 7.68121 163.864 8.28278 164.229C8.8889 164.594 9.69098 165.314 10.689 166.389C11.4957 167.255 12.0425 167.786 12.3297 167.982C12.7261 168.246 13.1181 168.378 13.5054 168.378C13.9338 168.378 14.2619 168.262 14.4898 168.03C14.7222 167.802 14.8384 167.485 14.8384 167.08C14.8384 166.679 14.7177 166.36 14.4761 166.123C14.2346 165.886 13.8336 165.749 13.273 165.712L13.4644 163.798C14.5217 163.912 15.2805 164.27 15.7408 164.872C16.2011 165.473 16.4312 166.225 16.4312 167.127C16.4312 168.116 16.1646 168.893 15.6314 169.458C15.0982 170.024 14.4351 170.306 13.6422 170.306C13.191 170.306 12.7603 170.224 12.3502 170.06C11.9446 169.901 11.5185 169.645 11.0718 169.294C10.7756 169.062 10.3495 168.643 9.79352 168.037C9.23753 167.431 8.86839 167.045 8.6861 166.881C8.5038 166.722 8.32607 166.592 8.15289 166.492L8.15289 170.306Z",
    fill: "url(#paint26_linear_4722_64610)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 166.133,
    r: 8.8367,
    transform: "rotate(90 10.8367 166.133)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8367,
    cy: 166.133,
    r: 6.8367,
    transform: "rotate(90 10.8367 166.133)",
    stroke: "#DBDBDB",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15094 170.603L6.36676 170.603L6.36676 163.869C7.04124 163.942 7.67926 164.161 8.28082 164.525C8.88694 164.89 9.68903 165.61 10.6871 166.686C11.4937 167.551 12.0406 168.082 12.3277 168.278C12.7242 168.543 13.1161 168.675 13.5035 168.675C13.9319 168.675 14.26 168.559 14.4879 168.326C14.7203 168.098 14.8365 167.782 14.8365 167.376C14.8365 166.975 14.7157 166.656 14.4742 166.419C14.2326 166.182 13.8316 166.045 13.2711 166.009L13.4625 164.095C14.5198 164.209 15.2785 164.566 15.7388 165.168C16.1991 165.77 16.4293 166.521 16.4293 167.424C16.4293 168.413 16.1627 169.19 15.6295 169.755C15.0963 170.32 14.4332 170.603 13.6402 170.603C13.189 170.603 12.7584 170.521 12.3482 170.356C11.9426 170.197 11.5165 169.942 11.0699 169.591C10.7737 169.358 10.3476 168.939 9.79156 168.333C9.23558 167.727 8.86643 167.342 8.68414 167.178C8.50185 167.018 8.32412 166.888 8.15094 166.788L8.15094 170.603Z",
    fill: "#DBDBDB"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8387,
    cy: 165.837,
    r: 8.8367,
    transform: "rotate(90 10.8387 165.837)",
    fill: "white",
    stroke: "url(#paint27_linear_4722_64610)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4722_64610",
    x1: 9.83866,
    y1: 2.03027,
    x2: 9.83866,
    y2: 17.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4722_64610",
    x1: 16.3687,
    y1: 9.86663,
    x2: 3.30755,
    y2: 9.86663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4722_64610",
    x1: 9.83866,
    y1: 2.03027,
    x2: 9.83866,
    y2: 17.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4722_64610",
    x1: 16.3687,
    y1: 9.86663,
    x2: 3.30755,
    y2: 9.86663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4722_64610",
    x1: 9.83866,
    y1: 2.03027,
    x2: 9.83866,
    y2: 17.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4722_64610",
    x1: 16.3687,
    y1: 9.86663,
    x2: 3.30755,
    y2: 9.86663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4722_64610",
    x1: 9.83866,
    y1: 2.03027,
    x2: 9.83866,
    y2: 17.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4722_64610",
    x1: 10.8387,
    y1: 54.0303,
    x2: 10.8387,
    y2: 69.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4722_64610",
    x1: 17.3687,
    y1: 61.8666,
    x2: 4.30755,
    y2: 61.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4722_64610",
    x1: 10.8387,
    y1: 54.0303,
    x2: 10.8387,
    y2: 69.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4722_64610",
    x1: 17.3687,
    y1: 61.8666,
    x2: 4.30755,
    y2: 61.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4722_64610",
    x1: 10.8387,
    y1: 54.0303,
    x2: 10.8387,
    y2: 69.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4722_64610",
    x1: 17.3687,
    y1: 61.8666,
    x2: 4.30755,
    y2: 61.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4722_64610",
    x1: 10.8387,
    y1: 54.0303,
    x2: 10.8387,
    y2: 69.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4722_64610",
    x1: 10.8387,
    y1: 104,
    x2: 10.8387,
    y2: 119.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4722_64610",
    x1: 17.3687,
    y1: 111.836,
    x2: 4.30755,
    y2: 111.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4722_64610",
    x1: 10.8387,
    y1: 104,
    x2: 10.8387,
    y2: 119.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4722_64610",
    x1: 17.3687,
    y1: 111.836,
    x2: 4.30755,
    y2: 111.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4722_64610",
    x1: 10.8387,
    y1: 104,
    x2: 10.8387,
    y2: 119.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4722_64610",
    x1: 17.3687,
    y1: 111.836,
    x2: 4.30755,
    y2: 111.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4722_64610",
    x1: 10.8387,
    y1: 104,
    x2: 10.8387,
    y2: 119.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4722_64610",
    x1: 10.8387,
    y1: 158,
    x2: 10.8387,
    y2: 173.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4722_64610",
    x1: 17.3687,
    y1: 165.836,
    x2: 4.30755,
    y2: 165.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4722_64610",
    x1: 10.8387,
    y1: 158,
    x2: 10.8387,
    y2: 173.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4722_64610",
    x1: 17.3687,
    y1: 165.836,
    x2: 4.30755,
    y2: 165.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4722_64610",
    x1: 10.8387,
    y1: 158,
    x2: 10.8387,
    y2: 173.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4722_64610",
    x1: 17.3687,
    y1: 165.836,
    x2: 4.30755,
    y2: 165.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4722_64610",
    x1: 10.8387,
    y1: 158,
    x2: 10.8387,
    y2: 173.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507152,
    stopColor: "#FF8B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourItemList);
export default __webpack_public_path__ + "static/media/four-item-list.5b084681e097ae0ef668cf32a0fa4d4e.svg";
export { ForwardRef as ReactComponent };